export default __webpack_public_path__ + "static/media/Sr._Theresa_img_041.96a41a6c.jpg";